"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _ANGAssetAdapter_instances, _ANGAssetAdapter_scoreHit, _ANGAssetAdapter_source, _ANGAssetAdapter_types, _ANGAssetAdapter_latestSource, _ANGAssetAdapter_version, _ANGAssetAdapter_getMinorVersionNode, _ANGAssetAdapter_getLatestMinorVersionNode, _ANGAssetAdapter_getVersionNode, _ANGAssetAdapter_getAssetNode, _ANGAssetAdapter_getFileNode, _ANGAssetAdapter_getCustomerMetadataNode, _ANGAssetAdapter_getSystemMetadataNode, _ANGAssetAdapter_getOrganizationNode, _ANGAssetAdapter_getUserNode;
Object.defineProperty(exports, "__esModule", { value: true });
const semver_1 = __importDefault(require("semver"));
const keys_1 = require("../keys");
const utils_1 = require("../utils");
class ANGAssetAdapter {
    constructor(hit, types) {
        _ANGAssetAdapter_instances.add(this);
        _ANGAssetAdapter_scoreHit.set(this, void 0);
        _ANGAssetAdapter_source.set(this, void 0);
        _ANGAssetAdapter_types.set(this, void 0);
        _ANGAssetAdapter_latestSource.set(this, void 0);
        _ANGAssetAdapter_version.set(this, void 0);
        const latest = (0, utils_1.getLatestHits)(hit);
        __classPrivateFieldSet(this, _ANGAssetAdapter_scoreHit, hit[keys_1.SCORE_KEY], "f");
        __classPrivateFieldSet(this, _ANGAssetAdapter_source, hit[keys_1.SOURCE_KEY], "f");
        __classPrivateFieldSet(this, _ANGAssetAdapter_types, types, "f");
        __classPrivateFieldSet(this, _ANGAssetAdapter_latestSource, latest[keys_1.SOURCE_KEY], "f");
    }
    static getMetadataByKey(values) {
        const keyValueMapping = (values !== null && values !== void 0 ? values : []).reduce((accum, current) => {
            var _a;
            const [key, value] = current.split(':');
            // eslint-disable-next-line no-param-reassign
            accum[key] = ((_a = accum[key]) !== null && _a !== void 0 ? _a : []).concat(value);
            return accum;
        }, {});
        return Object.keys(keyValueMapping).map((key) => ({
            key,
            value: keyValueMapping[key]
        }));
    }
    get angId() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_source, "f").assets, '@id');
    }
    get score() {
        return __classPrivateFieldGet(this, _ANGAssetAdapter_scoreHit, "f");
    }
    get groupId() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getMinorVersionNode).call(this), 'groupId');
    }
    get assetId() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getMinorVersionNode).call(this), 'assetId');
    }
    get icon() {
        const packaging = (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getFileNode).call(this), 'packaging');
        const sha1 = (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getFileNode).call(this), 'sha1');
        if (!packaging || !sha1) {
            return null;
        }
        return `/exchange/organizations/${this.organization.id}/assets/${this.groupId}/${this.assetId}/icon/${packaging}/?sha=${sha1}`;
    }
    get iconMetadata() {
        const packaging = (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getFileNode).call(this), 'packaging');
        const sha1 = (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getFileNode).call(this), 'sha1');
        if (!packaging || !sha1) {
            return null;
        }
        return {
            packaging,
            sha1
        };
    }
    get createdAt() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getVersionNode).call(this), 'createdAt');
    }
    get status() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getVersionNode).call(this), 'status');
    }
    get minorVersionModifiedAt() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getLatestMinorVersionNode).call(this), 'updatedAt');
    }
    get modifiedAt() {
        return this.minorVersionModifiedAt;
    }
    get createdBy() {
        const userNode = __classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getUserNode).call(this);
        if (userNode) {
            return {
                id: (0, utils_1.getProp)(userNode, 'id'),
                firstName: (0, utils_1.getProp)(userNode, 'firstName'),
                lastName: (0, utils_1.getProp)(userNode, 'lastName'),
                userName: (0, utils_1.getProp)(userNode, 'userName')
            };
        }
        return null;
    }
    get description() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getAssetNode).call(this), 'description');
    }
    get labels() {
        const customerMetadata = __classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getCustomerMetadataNode).call(this);
        if (!customerMetadata) {
            return [];
        }
        const tags = customerMetadata.tags || [];
        const keyValueTags = (customerMetadata.keyValueTags || []).map((keyValueTag) => keyValueTag.split(':')[1]);
        return [...tags, ...keyValueTags];
    }
    get categories() {
        const customerMetadata = __classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getCustomerMetadataNode).call(this);
        if (!customerMetadata) {
            return [];
        }
        return ANGAssetAdapter.getMetadataByKey(customerMetadata.categories);
    }
    get fields() {
        const customerMetadata = __classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getCustomerMetadataNode).call(this);
        if (!customerMetadata) {
            return [];
        }
        return ANGAssetAdapter.getMetadataByKey(customerMetadata.fields);
    }
    get minorVersion() {
        const latestVersion = this.version;
        const minorVersion = `${semver_1.default.major(latestVersion)}.${semver_1.default.minor(latestVersion)}`;
        return minorVersion;
    }
    get versionGroup() {
        return this.version;
    }
    get version() {
        if (__classPrivateFieldGet(this, _ANGAssetAdapter_version, "f")) {
            return __classPrivateFieldGet(this, _ANGAssetAdapter_version, "f");
        }
        const semverVersions = __classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getVersionNode).call(this).semverVersion;
        const latestVersion = semverVersions.sort(semver_1.default.rcompare)[0];
        return latestVersion;
    }
    set version(version) {
        __classPrivateFieldSet(this, _ANGAssetAdapter_version, version, "f");
    }
    get name() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getAssetNode).call(this), 'name');
    }
    get numberOfRates() {
        const numberOfRatings = (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getLatestMinorVersionNode).call(this), 'numberOfRatings');
        return parseInt(numberOfRatings || 0, 10);
    }
    get rating() {
        const averageRating = (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getLatestMinorVersionNode).call(this), 'averageRating');
        return parseInt(averageRating || 0, 10);
    }
    get organization() {
        const organizationNode = __classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getOrganizationNode).call(this);
        return {
            name: (0, utils_1.getProp)(organizationNode, 'name'),
            domain: (0, utils_1.getProp)(organizationNode, 'domain'),
            id: (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getAssetNode).call(this), 'organizationId')
        };
    }
    get type() {
        const angType = __classPrivateFieldGet(this, _ANGAssetAdapter_source, "f").assets[keys_1.ANG_TYPE];
        const foundType = Object.keys(__classPrivateFieldGet(this, _ANGAssetAdapter_types, "f")).find((type) => angType.includes(__classPrivateFieldGet(this, _ANGAssetAdapter_types, "f")[type].angType));
        return foundType;
    }
    get minMuleVersion() {
        const systemMetadata = __classPrivateFieldGet(this, _ANGAssetAdapter_instances, "m", _ANGAssetAdapter_getSystemMetadataNode).call(this);
        return (0, utils_1.getProp)(systemMetadata, 'minMuleVersion');
    }
    parse() {
        return (0, utils_1.getInstanceProps)(this);
    }
    toAsset() {
        return this.parse();
    }
}
_ANGAssetAdapter_scoreHit = new WeakMap(), _ANGAssetAdapter_source = new WeakMap(), _ANGAssetAdapter_types = new WeakMap(), _ANGAssetAdapter_latestSource = new WeakMap(), _ANGAssetAdapter_version = new WeakMap(), _ANGAssetAdapter_instances = new WeakSet(), _ANGAssetAdapter_getMinorVersionNode = function _ANGAssetAdapter_getMinorVersionNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_source, "f"), 'asset-minor-versions', 'MinorVersionNode');
}, _ANGAssetAdapter_getLatestMinorVersionNode = function _ANGAssetAdapter_getLatestMinorVersionNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_latestSource, "f"), 'asset-minor-versions', 'MinorVersionNode');
}, _ANGAssetAdapter_getVersionNode = function _ANGAssetAdapter_getVersionNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_latestSource, "f"), 'asset-minor-versions', 'VersionNode');
}, _ANGAssetAdapter_getAssetNode = function _ANGAssetAdapter_getAssetNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_source, "f"), 'assets', 'AssetNode');
}, _ANGAssetAdapter_getFileNode = function _ANGAssetAdapter_getFileNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_source, "f"), 'assets', 'FileNode');
}, _ANGAssetAdapter_getCustomerMetadataNode = function _ANGAssetAdapter_getCustomerMetadataNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_latestSource, "f"), 'customer-metadata', 'CustomerMetadataNode');
}, _ANGAssetAdapter_getSystemMetadataNode = function _ANGAssetAdapter_getSystemMetadataNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_latestSource, "f"), 'system-metadata', 'SystemMetadataNode');
}, _ANGAssetAdapter_getOrganizationNode = function _ANGAssetAdapter_getOrganizationNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_source, "f"), 'organizations', 'OrganizationNode');
}, _ANGAssetAdapter_getUserNode = function _ANGAssetAdapter_getUserNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetAdapter_latestSource, "f"), 'users', 'UserNode');
};
exports.default = ANGAssetAdapter;
